<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'otherSecurities.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="otherSecuritiesBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "accountData.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "accountData.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="otherSecuritiesBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #otherSecuritiesBlock>
  <form [formGroup]="otherSecuritiesForm">
    <div left-content class="content-container">
      <app-textarea
        [control]="other"
        [label]="'otherSecurities.writeHere'"
        (blurEvent)="otherSecuritiesDescriptionUpdate()"
      ></app-textarea>
      <app-file-uploader
        [label]="'otherSecurities.otherOptional'"
        [control]="otherSecuritiesFiles"
        [controlName]="'otherSecuritiesFiles'"
        [applicationId]="applicationId"
        [uploaderName]="assetName.OTHER"
        [isSummary]="isSummary"
      ></app-file-uploader>

      <app-infobox
        [title]="'otherSecurities.infobox.title' | translate"
        [content]="'otherSecurities.infobox.content' | translate"
      >
      </app-infobox>
    </div>
  </form>
</ng-template>
